<template>
  <div class="page-container">
    <div>
      <section id="send-form">
        <form
          class="md-layout text-center col-11 mx-auto"
          @submit.prevent="validate"
        >
          <md-card class="form">
            <md-card-header class="p-2">
              <h4 class="mt-2">パスワード設定</h4>
            </md-card-header>
            <md-card-content>
              <div class="md-layout md-gutter mt-3">
                <div class="md-layout-item">
                  <md-field :class="isValidationClass.userId">
                    <label for="userId">ID</label>
                    <md-input
                      name="userId"
                      id="userId"
                      autocomplete="userId"
                      v-model="form.userId"
                      @change="setValidationClass('userId')"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.userId.required">
                      入力必須です
                    </span>
                    <span class="md-error" v-else-if="!$v.form.userId.isEmoji">
                      絵文字は入力できません
                    </span>
                  </md-field>
                  <md-field :class="isValidationClass.password">
                    <label for="password">新規パスワード</label>
                    <md-input
                      name="password"
                      id="password"
                      type="password"
                      v-model="form.password"
                      @change="setValidationClass('password')"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.password.required">
                      入力必須です
                    </span>
                    <span class="md-error" v-else-if="!$v.form.password.psw">
                      半角英字と半角数字は1文字以上使用してください。
                    </span>
                    <span
                      class="md-error"
                      v-else-if="!$v.form.password.minLength"
                    >
                      6文字以上で入力してください
                    </span>
                    <span
                      class="md-error"
                      v-else-if="!$v.form.password.maxLength"
                    >
                      20文字以下で入力してください
                    </span>
                  </md-field>
                  <md-field :class="isValidationClass.confirm">
                    <label for="confirm">新規パスワード確認</label>
                    <md-input
                      name="confirm"
                      id="confirm"
                      type="password"
                      v-model="form.confirm"
                      @change="setValidationClass('confirm')"
                      :disabled="sending"
                    />
                    <span class="md-error" v-if="!$v.form.confirm.required">
                      入力必須です
                    </span>
                    <span class="md-error" v-else-if="!$v.form.confirm.sameAs">
                      パスワードが一致していません
                    </span>
                  </md-field>
                </div>
              </div>
              <md-button
                class="md-raised"
                type="submit"
                :disabled="!isSendAble"
              >
                登録
              </md-button>
            </md-card-content>
          </md-card>
        </form>
      </section>

      <p class="text-center">
        <router-link to="/kiyaku">
          <a>サイト利用規約</a>
        </router-link>
      </p>
    </div>

    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="
        scroll('clear')
        $router.push({ name: 'Login' })
      "
      :md-active.sync="isEdit"
      md-content="<strong>パスワードを更新しました。</strong>"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Valid from '@/valid'
import {
  required,
  maxLength,
  minLength,
  sameAs,
} from 'vuelidate/lib/validators'
import Mixin from '../mixin/Mixin'

const psw = (value) => Valid.isValidPassword(value) // パスワードバリデーション
const isEmoji = (value) => Valid.isEmoji(value)

export default {
  name: 'Edit',
  mixins: [validationMixin, Mixin],
  data: () => ({
    showApplyDialog: false,
    isSent: false,
    form: {
      userId: '',
      password: '',
      confirm: '',
      token: '',
    },
    logindata: {
      USER_ID: null,
      PASSWORD: null,
    },
    isValidationClass: {
      userId: null,
      password: null,
      confirm: null,
    },
    invalid: false,
    isEdit: false,
    sending: false,
  }),
  validations: {
    form: {
      userId: {
        required,
        isEmoji,
      },
      password: {
        required,
        psw,
        minLength: minLength(6),
        maxLength: maxLength(20),
      },
      confirm: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.auth.token
    },
    isPwEdit() {
      return this.$router.history.current.name === 'PasswordEdit'
    },
    isSendAble() {
      return (
        this.form.userId &&
        this.form.password &&
        this.form.confirm &&
        !this.$v.$invalid
      )
    },
  },
  methods: {
    createAccount() {
      // スピナー表示（グルグル画面）
      this.spinerOn()
      this.$store
        .dispatch(
          this.isPwEdit ? 'password/updatePW' : 'password/createAccount',
          this.form
        )
        .then((res) => {
          if (this.isPwEdit) {
            this.isEdit = true
          } else {
            this.login(res.data)
          }
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
      this.spinerOff()
    },
    login(user) {
      this.logindata.USER_ID = user.USER_ID
      this.logindata.PASSWORD = this.form.password
      this.$store
        .dispatch('auth/login', this.logindata)
        .then((res) => {
          this.$router.push({ name: 'Home' })
        })
        .catch((err) => {
          this._alert(err.message, false)
          this.spinerOff()
        })
    },
    getValidationMessage(validationKeyName, replaceTextArr) {
      let message = this.$t(`validate.${validationKeyName}`)
      for (let r of replaceTextArr) {
        message = message.replace('s:', this.$t(`item.${r}`))
      }
      return message
    },
    setValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        this.isValidationClass[fieldName] = { 'md-invalid': field.$invalid }
      }
    },
    validate() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.createAccount()
      } else {
        Object.keys(this.form).forEach((key) => {
          this.setValidationClass(key)
        }, this)
        this._alert('入力項目にエラーがあります。')
      }
    },
  },
  created: function () {
    if (this.$store.state.auth.token) {
      this.$router.push('Home')
    }
    this.$data.form.token = this.$route.query.token
  },
  watch: {
    token(newToken) {
      this.$router.push('Home')
    },
  },
  beforeCreate() {
    // this.$emit('changeLanguageTo', 'en')
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
section#send-form
  .md-card-header
    background: $baseBlueColor
    color: white
  .form
    width: 50%
    margin: 40px auto
    @include sp
      width: 100%
      margin: 10px auto
  .md-button
    @extend.base-btn
    @extend.f-size-16
    background: $baseGreenColor
    border-radius: 5px
#apply-modal
  @extend .base_modal
  width: $baseWidth * 0.6
  .modal-note
    @extend.red
    margin-left: 13%
</style>



// WEBPACK FOOTER //
// src/components/password/Edit.vue